import axios from "../httpHandler";
import { isBlank } from "helpers/strings";

///report_type in (purchase, dist, concentrate, warehouse)
export const getProvinceExcelReport = async (reportType, rawFilters) => {  
  try {    
    //check for extra '?' sign in passed filters (which is rawFilters)
    // if it started with '&?', just remove the '?' to avoid duplicates
    let filters = '';
    if (rawFilters.startsWith('?', 1)) {
      filters = `&${rawFilters.substring(2)}`;
    } else {
      filters = rawFilters;
    }

    const result = await axios.get(`report/excel?report_type=${reportType}${filters || ''}`);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

export const getBuysReport = async (filters) => {
  try {
    const listResult = await axios.get(`input/purchase${filters || ''}`);
    const statisticsResult = await axios.get(`input/purchase/statistics${filters || ''}`);
    return {
      list: listResult?.data,
      statistics: statisticsResult?.data,
    };
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getBuysReportSum = async (filters) => {
  try {
    const queryString = isBlank(filters) ? '?sum=true' : `${filters}sum=true`
    
    const listResult = await axios.get(`input/purchase${queryString}`);
    const statisticsResult = await axios.get(`input/purchase/statistics${queryString}`);
    return {
      list: listResult?.data,
      statistics: statisticsResult?.data,
    };
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteBuyReport = async ({ id, warehouseSelected }) => {
  const queryParams = warehouseSelected ? '?update_warehouse' : '';
  return axios.delete(`input/purchase/${id}${queryParams}`);
};

export const updateBuyReport = (data) => {
  return axios.put(`input/purchase/${data?.id}`, {
    ...data,
  });
};

export const getDistsReport = async (filters) => {
  try {
    const listResult = await axios.get(`input/dist${filters || ''}`);
    const statisticsResult = await axios.get(`input/dist/statistics${filters || ''}`);
    return {
      list: listResult?.data,
      statistics: statisticsResult?.data,
    };
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getDistsReportSum = async (filters) => {
  try {
    const queryString = isBlank(filters) ? '?sum=true' : `${filters}sum=true`
    
    const listResult = await axios.get(`input/dist${queryString}`);
    const statisticsResult = await axios.get(`input/dist/statistics${queryString}`);
    return {
      list: listResult?.data,
      statistics: statisticsResult?.data,
    };
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteDistReport = async ({ id, warehouseSelected }) => {
  const queryParams = warehouseSelected ? '?update_warehouse' : '';
  return axios.delete(`input/dist/${id}${queryParams}`);
};

export const updateDistReport = (data) => {
  return axios.put(`input/dist/${data?.id}`, {
    ...data,
  });
};

export const getProductsReport = async (filters) => {
  try {
    const listResult = await axios.get(`concentrate${filters || ''}`);
    const statisticsResult = await axios.get(`concentrate/statistics${filters || ''}`);
    return {
      list: listResult?.data,
      statistics: statisticsResult?.data,
    };
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getProductsReportSum = async (filters) => {
  try {
    const queryString = isBlank(filters) ? '?sum=true' : `${filters}sum=true`
    
    const listResult = await axios.get(`concentrate${queryString}`);
    const statisticsResult = await axios.get(`concentrate/statistics${queryString}`);
    return {
      list: listResult?.data,
      statistics: statisticsResult?.data,
    };
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteProductItem = async ({ id, warehouseSelected }) => {
  const queryParams = warehouseSelected ? '?update_warehouse' : '';
  return axios.delete(`concentrate/item/${id}${queryParams}`);
};

export const updateProductReport = (data) => {
  return axios.put(`concentrate/${data?.id}`, {
    ...data,
  });
};

export const getStoreReport = async (filters) => {
  try {
    const result = await axios.get(`warehouse${filters || ''}`);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

export const getNonRegisteredBuysReport = async (filters) => {
  try {
    const result = await axios.get(`input/purchase/not-filled-unions${filters || ''}`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getNonRegisteredDistsReport = async (filters) => {
  try {
    const result = await axios.get(`input/dist/not-filled-unions${filters || ''}`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
